export const FETCH_HOSTS = 'FETCH_HOSTS';

export const FETCH_HOSTS_IS_PENDING = 'FETCH_HOSTS_IS_PENDING';

export const FETCH_HOSTS_IS_ERROR = 'FETCH_HOSTS_IS_ERROR';

export const FETCH_HOSTS_BY_ID = 'FETCH_HOSTS_BY_ID';

export const FETCH_HOSTS_BY_ID_IS_PENDING = 'FETCH_HOSTS_BY_ID_IS_PENDING';

export const FETCH_HOSTS_BY_ID_IS_ERROR = 'FETCH_HOSTS_BY_ID_IS_ERROR';

export const UPDATE_HOST = 'UPDATE_HOST';

export const UPDATE_HOST_IS_PENDING = 'UPDATE_HOST_IS_PENDING';

export const UPDATE_HOST_IS_ERROR = 'UPDATE_HOST_IS_ERROR';

export const FETCH_HOSTS_INSTANCE_TYPES = 'FETCH_HOSTS_INSTANCE_TYPES';

export const FETCH_HOSTS_INSTANCE_TYPES_IS_PENDING = 'FETCH_HOSTS_INSTANCE_TYPES_IS_PENDING';

export const FETCH_HOSTS_INSTANCE_TYPES_IS_ERROR = 'FETCH_HOSTS_INSTANCE_TYPES_IS_ERROR';

export const START_HOST = 'START_HOST';

export const START_HOST_IS_PENDING = 'START_HOST_IS_PENDING';

export const START_HOST_IS_ERROR = 'START_HOST_IS_ERROR';

export const STOP_HOST = 'STOP_HOST';

export const STOP_HOST_IS_PENDING = 'STOP_HOST_IS_PENDING';

export const STOP_HOST_IS_ERROR = 'STOP_HOST_IS_ERROR';

export const RESTART_HOST = 'RESTART_HOST';

export const RESTART_HOST_IS_PENDING = 'RESTART_HOST_IS_PENDING';

export const RESTART_HOST_IS_ERROR = 'RESTART_HOST_IS_ERROR';

export const SET_RDNS_HOST_NAME = 'SET_RDNS_HOST_NAME';

export const SET_RDNS_HOST_NAME_IS_PENDING = 'SET_RDNS_HOST_NAME_IS_PENDING';

export const SET_RDNS_HOST_NAME_IS_ERROR = 'SET_RDNS_HOST_NAME_IS_ERROR';

export const CANCEL_HOST = 'CANCEL_HOST';

export const CANCEL_HOST_IS_PENDING = 'CANCEL_HOST_IS_PENDING';

export const CANCEL_HOST_IS_ERROR = 'CANCEL_HOST_IS_ERROR';

export const REVERT_CANCEL_HOST = 'REVERT_CANCEL_HOST';

export const REVERT_CANCEL_HOST_IS_PENDING = 'REVERT_CANCEL_HOST_IS_PENDING';

export const REVERT_CANCEL_HOST_IS_ERROR = 'REVERT_CANCEL_HOST_IS_ERROR';

export const FETCH_INVOICES = 'FETCH_INVOICES_HOST';

export const FETCH_INVOICES_IS_PENDING = 'FETCH_INVOICES_HOST_IS_PENDING';

export const FETCH_INVOICES_IS_ERROR = 'FETCH_INVOICES_HOST_IS_ERROR';

export const FETCH_ALERTS = 'FETCH_ALERTS_HOST';

export const FETCH_ALERTS_IS_PENDING = 'FETCH_ALERTS_HOST_IS_PENDING';

export const FETCH_ALERTS_IS_ERROR = 'FETCH_ALERTS_HOST_IS_ERROR';

export const CREATE_ALERTS = 'CREATE_ALERTS_HOST';

export const CREATE_ALERTS_IS_PENDING = 'CREATE_ALERTS_HOST_IS_PENDING';

export const CREATE_ALERTS_IS_ERROR = 'CREATE_ALERTS_HOST_IS_ERROR';

export const EDIT_ALERTS = 'EDIT_ALERTS_HOST';

export const EDIT_ALERTS_IS_PENDING = 'EDIT_ALERTS_HOST_IS_PENDING';

export const EDIT_ALERTS_IS_ERROR = 'EDIT_ALERTS_HOST_IS_ERROR';

export const DELETE_ALERTS = 'DELETE_ALERTS_HOST';

export const DELETE_ALERTS_IS_PENDING = 'DELETE_ALERTS_HOST_IS_PENDING';

export const DELETE_ALERTS_IS_ERROR = 'DELETE_ALERTS_HOST_IS_ERROR';

export const SORT_HOSTS = 'SORT_HOSTS';

export const FILTER_HOSTS = 'FILTER_HOSTS';

export const RESET_REDUCER = 'RESET_HOSTS_REDUCER';

export const FETCH_BMC_STATUS = 'FETCH_BMC_STATUS';

export const FETCH_BMC_STATUS_IS_PENDING = 'FETCH_BMC_STATUS_IS_PENDING';

export const FETCH_BMC_STATUS_IS_ERROR = 'FETCH_BMC_STATUS_IS_ERROR';
